import React from 'react';
import Spin from 'antd/lib/spin';
import ReactDom from 'react-dom';
var styles = {
    backdrop: {
        width: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: 9999999,
        left: 0,
        top: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        overflow: 'hidden'
    }
};
export var EntireBackdrop = function (props) { return (props.open ? React.createElement("div", { style: styles.backdrop }, props.children) : null); };
export function EntireLoader(props) {
    var modalPlaceholderElement = document.getElementById('root');
    return ReactDom.createPortal(React.createElement(EntireBackdrop, { open: props.open },
        React.createElement(Spin, { size: "large" })), modalPlaceholderElement);
}
